import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

export default class Well extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        title: PropTypes.string,
        className: PropTypes.string,
        tipTitleCollapsed: PropTypes.string,
        tipTitleExpanded: PropTypes.string,
        tipBody: PropTypes.string,
        helper: PropTypes.string,
    };
    static defaultProps = {
        children: null,
        tipBody: null,
        className: '',
        tipTitleCollapsed: 'Show Foap tip',
        tipTitleExpanded: 'Hide Foap tip',
        helper: null,
    };
    state = {
        title: null,
        tipExpanded: false
    };

    render() {
        const { tipExpanded } = this.state;
        const { children, title, className, tipTitleCollapsed, tipTitleExpanded, tipBody, helper } = this.props;

        return (
            <div className={`component-well ${className}`}>
                <div className="well-body">
                    <div className="well-header">
                        {title &&
                            <h3 className="well-title">
                                {title}
                            </h3>
                        }
                        {helper &&
                            <p className="well-helper">
                                <span className="well-title-tip-label">
                                    ?
                                </span>
                                <span className="well-title-tip-content">
                                    {helper}
                                </span>
                            </p>
                        }
                        {/* {helper && (
                            <div className="well-title-tip" data-tip={helper}>
                                <ReactTooltip place="top" type="light" effect="solid" />
                                <span className="well-title-tip-label">
                                    ?
                                </span>
                            </div>
                        )} */}
                    </div>
                    <div className="well-children">
                        {children}
                    </div>
                </div>
                {tipBody &&
                    <div className="well-tip">
                        <div className="tip-header">
                            <div className="col-left">
                                <div
                                    className={`tip-control tip-collapse-control ${tipExpanded && 'expanded'}`}
                                    onClick={() => this.setState(prevState => ({ ...prevState, tipExpanded: !prevState.tipExpanded }))}
                                >
                                    <i className="fa fa-chevron-down"></i>
                                    <p className="">{tipExpanded ? tipTitleExpanded : tipTitleCollapsed}</p>
                                </div>
                            </div>
                            <div className="col-rigt">
                                <div className="tip-control tip-info-control">
                                    <i className="fa fa-info-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`tip-body animated ${tipExpanded ? 'expanded fadeInDown' : 'fadeOutUp'}`}
                            dangerouslySetInnerHTML={{ __html: tipBody }}
                        />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Well/index.js